import React, { useContext, useEffect, useState } from "react"
import Header from "../Global/Header"
import PageContent from "../Global/PageContent"
import { useNavigate, Link } from "react-router-dom"
import Timeline from "../Global/Timeline"
import { FiArrowRight, FiChevronDown, FiSearch, FiEdit } from "react-icons/fi"
import Popup from "../Global/Popup/"
import removerAcentos from "../../inc/Fx/removerAcentos"
import toggleRef from "../../inc/Fx/toggleRef"
import { GlobalContext } from "../../contexts/global"
import api from "../../services/api"
import PopupEspecialidadeEspontanea from "../Agendamento/PopupEspepecialidade"
import "./style.css"
import updateLead from "../../inc/Fx/updateLead"
import { getGrupoByUnidadeId, grupoMatchesFilter } from "../../inc/grupoUnidades"

export default function Unidade() {
  const [popup_unidade, toggle_popup_unidade] = useState(false)
  const [unidade, set_unidade] = useState("Escolha a unidade")
  const [is_popup_submit_disabled, disable_popup_submit] = useState(true)
  const [is_body_submit_disabled, disable_body_submit] = useState(true)
  const navigate = useNavigate()
  const [isInputFilled, setInputFilled] = useState(false)
  const [filterUnits, setFilterUnits] = useState()
  const [htmlUnidades, setHtmlUnidades] = useState()
  const {setLoaderState} = useContext(GlobalContext)

  const unidadesRaw = window.sessionStorage.getItem("units");
  let unidadesObj = {}
  try { unidadesObj = unidadesRaw ? JSON.parse(unidadesRaw) : {} } catch(e) {}
  const unidades = Object.keys(unidadesObj).map(key => unidadesObj[key]);

  const convenio = window.sessionStorage.getItem("convenio")
  
  const [isEspecialidadeEspontanea, setEspecialidadeEspontanea] = useState(false)

  const search_handle = (text) => {
    toggleRef({
      querySelector: "unidade",
      text: removerAcentos(text),
    })
  }

  
  useEffect(() => {
    if (convenio && convenio.includes("::")) {
      const idCovenio = convenio.split("::")[1]
      setLoaderState(true)
      api
        .get("/units?convenio=" + idCovenio)
        .then((response) => {
          if (response.data.units)
            setFilterUnits(response.data.units)
            setLoaderState(false)
        })
        .catch((err) => {
          console.log(err)
          setLoaderState(false)
        })
    }
  }, [])

  // Seleciona uma opção (unidade comum ou grupo). value = "Nome::id::Regional", onde
  // `id` é o ID numérico da unidade ou o grupoId (ex: "NOVA_IGUACU").
  const selectOption = (value) => {
    set_unidade(value)
    disable_popup_submit(false)
    disable_body_submit(false)
    toggle_popup_unidade(false)
  }

  useEffect(() => {
    const html = []
    const gruposRenderizados = new Set()

    Object.keys(unidades).forEach((index) => {
      const unidade = unidades[index]
      const grupo = getGrupoByUnidadeId(unidade.id)

      // Unidades de um grupo (ex: os 4 IDs de Nova Iguaçu - Centro) viram um único
      // card. O endereço específico não é mostrado aqui — só é resolvido no fim do
      // fluxo, a partir do horário escolhido.
      if (grupo) {
        if (gruposRenderizados.has(grupo.grupoId)) return
        if (!grupoMatchesFilter(grupo, filterUnits)) return
        gruposRenderizados.add(grupo.grupoId)

        const value = `${grupo.nome}::${grupo.grupoId}::${grupo.regional}`
        html.push(
          <div
            key={`grupo-${grupo.grupoId}`}
            className="input-radio-capsule"
            style={{ marginBottom: "8px" }}
            unidade={removerAcentos(grupo.regional)}
          >
            <label>
              <input
                type="radio"
                name="input-unidade"
                value={value}
                onChange={() => selectOption(value)}
              />
              <div className="icon">
                <span></span>
              </div>
              <div id="adress" className="label label_adress">
                <p>
                  {grupo.regional}
                  <br />
                  <span>{grupo.nome}</span>
                </p>
              </div>
            </label>
          </div>
        )
        return
      }

      if (filterUnits && !filterUnits.includes(unidade.id)) {
        return
      }

      const value = `${unidade.nome}::${unidade.id}::${unidade.regional}`
      html.push(
        <div
          key={index}
          className="input-radio-capsule"
          style={{ marginBottom: "8px" }}
          unidade={removerAcentos(unidade.regional)}
        >
          <label>
            <input
              type="radio"
              name="input-unidade"
              value={value}
              onChange={() => selectOption(value)}
            />
            <div className="icon">
              <span></span>
            </div>
            <div id="adress" className="label label_adress">
              <p>
                {unidade.regional}
                <br />
                <span>{unidade.nome}<br />
                {unidade.endereco}</span>
              </p>
            </div>
          </label>
        </div>
      )
    })

    setHtmlUnidades(html)
  }, [filterUnits])

  function open_popup(e) {
    e.preventDefault()
    toggle_popup_unidade(true)
  }

  const handle_submit = (e) => {
    e.preventDefault()
    sessionStorage.setItem("unidade", unidade)
    navigate("/medico")
  }
  updateLead({
    UNIDADE: unidade.split("::")[0]
  })

  const handle_popup_submit = (e) => {
    e.preventDefault()
    disable_body_submit(false)
    setInputFilled(true)
    toggle_popup_unidade()
  }
  const { statusSegmais } = useContext(GlobalContext)
  const mainClassName = statusSegmais ? "page-segmais" : ""

  return (
    <main className={`site-main page-unidade ${mainClassName}`}>
        {isEspecialidadeEspontanea && (
          <PopupEspecialidadeEspontanea close={setEspecialidadeEspontanea} />
        )}
      <Header back_to="/especialidade">
        <h1>Unidade</h1>
      </Header>
      <PageContent>
        <Timeline step={2} />
        <Popup ID="unidade" open={popup_unidade} handle={toggle_popup_unidade}>
          <form onSubmit={handle_popup_submit}>
            <div
              className="input-text input-search"
              style={{ marginBottom: "1.75rem" }}
            >
              <label htmlFor="search-unidade">
                <input
                  type="text"
                  name="search-unidade"
                  id="search-unidade"
                  onKeyUp={(e) => search_handle(e.target.value)}
                  placeholder="Buscar unidade"
                />
                <FiSearch />
              </label>
            </div>
            {htmlUnidades}
            {htmlUnidades && htmlUnidades.length === 0 && (
              <p className="unidade-sem-agenda">
                Não há agenda disponível para esta especialidade no momento.
                Tente outra especialidade ou volte mais tarde.
              </p>
            )}
            {/* <div
              className={`input-submit ${
                is_popup_submit_disabled ? "disabled" : ""
              }`}
            >
              <button type="submit">Confirmar</button>
            </div> */}
          </form>
        </Popup>

        <form onSubmit={handle_submit}>
          <Link
            className={`selector-format ${isInputFilled ? "filled" : ""}`}
            onClick={(e) => open_popup(e)}
          >
            <span>
              {unidade.split("::")[0]}
              <FiEdit size={8} />
            </span>
            <FiChevronDown />
          </Link>

          <div
            className={`input-submit ${
              is_body_submit_disabled ? "disabled" : ""
            }`}
          >
            <button type="submit" disabled={is_body_submit_disabled}>
              Prosseguir
              <FiArrowRight />
            </button>
          </div>
        </form>
      </PageContent>
    </main>
  )
}
